module.exports = __webpack_public_path__ + "static/m_solution5-a02b19fad0d64c488b8cd639d29e5fc2.png";